// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class FormView extends JQueryView {
  constructor() {
    super('.investor_document_groups.video');
    if ($('.form-control').val().length !== 0) {
      $('.delete-url-link').show();
    }
  }

  @on({ event: 'change', selector: '.form-control' })
  onBlurFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length === 0) {
      this.removeDeleteLink();
    } else {
      $('.delete-url-link').show();
    }
    this.removeNotify();
  }

  @on({ event: 'focus', selector: '.url-input-area' })
  onUrlInputArea() {
    $('.save-url-button').show();
    $('.delete-url-link').removeClass('invalid');
  }

  @on({ event: 'click', selector: '.save-url-button' })
  onClickSubmitButton(event: any) {
    const target = $(event.target);
    target.hide();
  }

  @on({ event: 'click', selector: '.delete-url-link' })
  onClickDeleteUrlLink() {
    $('.form-control').val('');
    $('.video-content').html('');
    $('.save-url-button').hide();
    this.removeDeleteLink();
    this.removeNotify();
  }

  removeDeleteLink() {
    $('.delete-url-link').hide();
    $('.video-modal-notify').empty();
  }

  removeNotify() {
    $('.invalid-feedback').text('');
    $('.form-control').removeClass('is-invalid');
  }
}
